import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useMe } from '@/lib/hooks';

const IS_MOCK = !import.meta.env.VITE_API_BASE_URL;

/**
 * Route guard for Admin-only sections (Templates, User Access). Non-admins are
 * redirected to the dashboard rather than shown a page whose API calls all 403.
 */
export function RequireAdmin({ children }: { children: ReactNode }) {
  const { data: me, isLoading } = useMe();
  const isAdmin = IS_MOCK || (me?.roles?.includes('Admin') ?? false);

  if (!IS_MOCK && isLoading) return null; // wait for /api/me before deciding
  if (!isAdmin) return <Navigate to="/" replace />;
  return <>{children}</>;
}
